'use strict';

var _model = require('common/models/base/model');

var _model2 = _interopRequireDefault(_model);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Signature object
 *
 * @property String type               Signature or initials
 * @property String createType         Method used to create the signature
 * @property Array signature           Raw signature data (only set when new)
 * @property String guid               Identifier
 * @property Date createdAt            Creation time
 * @property Date lastUsedAt           Last time it was used (null = never)
 * @property Integer width             Image width in pixels
 * @property Integer height            Image height in pixels
 * @property String  file              File path to upload (null except when uploading)
 * @property Object  editParams        Parameters (x, y, width, height, threshold, degrees) to send for image editing (null when not editing)
 * @property String  emailGuid         signature_email_guid or initials_email_guid
 */

module.exports = _model2['default'].extend({

    apiEndpointAlias: 'signature',

    TYPE_INITIALS: 'I',
    TYPE_SIGNATURE: 'S',

    mixins: [require('common/models/mixins/model')],

    /*
     * Takes optional threshold parameters for signature editing
     */
    getUrl: function getUrl(threshold, degrees) {

        var uri = '/attachment/view?sig_guid=' + this.guid;

        if (arguments.length > 0) {
            uri = '/attachment/view?sig_guid=' + this.guid;
            uri += '&threshold=' + threshold + '&degrees=' + (degrees || 0);
        }

        return _hfReactHelper2['default'].attachSessionInfoToUrl(uri);
    },


    //  ----  DATA  ---------------------------------------

    toData: function toData() {
        return {
            'guid': this.guid,
            'createdAt': this.createdAt,
            'lastUsedAt': this.lastUsedAt,
            'width': this.width,
            'height': this.height,
            'type': this.type,
            'signature': this.signature,
            'file': this.file,
            'emailGuid': this.emailGuid
        };
    },
    fromData: function fromData(data) {
        if (data) {
            return {
                'type': data.type_code,
                'createType': data.create_type_code,
                'guid': data.signature_id,
                'createdAt': data.created_at ? new Date(data.created_at * 1000) : null,
                'lastUsedAt': data.last_used_at ? new Date(data.last_used_at * 1000) : null,
                'width': data.width,
                'height': data.height,
                'signature': data.signature || null
            };
        }
    },
    getEditParams: function getEditParams() {
        return {
            'width': this.width,
            'height': this.height,
            'editParams': this.editParams
        };
    },


    //  ----  ACTIONS  ------------------------------------

    rotate: function rotate(onRotate) {
        onRotate = onRotate || function () {};
        return this.fetch('rotate').then(onRotate.bind(null, void 0))['catch'](onRotate);
    },
    markAsPrimary: function markAsPrimary() {
        return this.fetch('markAsPrimary');
    },


    /*
     * Used for saving cropping / contrast / rotation results
     * TODO - make this more descriptive -- edit() is a bit vague (CC)
     */

    edit: function edit() {
        return this.fetch('edit');
    },


    /*
     * Sets options for the crop endpoint edit step
     */
    setEditParams: function setEditParams(editParams) {
        this.editParams = editParams;
    },


    /*
     * Gets status / signature guids / new email guids
     */
    checkEmailSignatureStatus: function checkEmailSignatureStatus() {
        return this.fetch('checkEmailSignatureStatus');
    },


    //  ----  HELPERS  ------------------------------------

    isInitials: function isInitials() {
        return this.type === this.TYPE_INITIALS;
    },
    isSignature: function isSignature() {
        return this.type === this.TYPE_SIGNATURE;
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/models/signature.js
 ** module id = 516
 ** module chunks = 0 1
 **/